import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import compose from 'recompose/compose';
import { reduxForm, Field, change } from 'redux-form';
import FormCheckBoxWithLabel from '../legacyForm/FormCheckBoxWithLabel';
import BudgetApplicationListOfSupportPerson from './BudgetApplicationListOfSupportPerson';
import { Typography } from '@material-ui/core';

const required = value => value ? undefined : 'Pole jest wymagane';

let BudgetApplicationListOfSupportForm = ({
  handleSubmit,
  change,
  submitting,
  applicationForm,
  disabled,
  unit,
  readonly,
  canSubmit,
   }) => {

  return (
    <form onSubmit={handleSubmit} noValidate>
      <div className="row">
        <div className="box-header-outside">
          <div className="col-sm-12">
            <div className="header">
              <h2>Formularz zgłoszenia poparcia</h2>
            </div>
          </div>
        </div>
        <div className="box">
          <div className="col-sm-12">
            <BudgetApplicationListOfSupportPerson requiredData={applicationForm.requiredData || {}} change={change} readonly={readonly} />
            <div className="rodo" style={{ marginTop: 20, marginBottom: 20 }}>
              <div dangerouslySetInnerHTML={{ __html: unit.policy }} />
            </div>
            
            {canSubmit && applicationForm.approvals && applicationForm.approvals.length
              ? <React.Fragment>
                {applicationForm.approvals.map(approval => (
                  <div key={approval.id}>
                    <Field
                      name={`approval_${approval.id}`}
                      component={FormCheckBoxWithLabel}
                      label={<div className="approval" dangerouslySetInnerHTML={{ __html: approval.value }} />}
                      fullWidth
                      validate={required}
                      disabled={readonly}
                    />
                  </div>
                ))}
              </React.Fragment>
              : null}

              {applicationForm.requiredDataPublic
                ? <div>
                  <Field
                    name="isPublic"
                    component={FormCheckBoxWithLabel}
                    label="Wyrażam zgodę na udostępnienie moich danych na liście poparcia (imię, nazwisko). Jeżeli nie wyrazisz zgody, Twoje dane będą anonimowe."
                    fullWidth
                    disabled={readonly}
                  />
                  <div>
                    <Typography variant="caption">Pole jest nieobowiązkowe</Typography>
                  </div>
                </div>
                : null}
          </div>
        </div>
      </div>
      
      <div className="row">
        <div className="col-xs-12" style={{ marginRight: 15 }}>
          <button type="submit" disabled={submitting || disabled || readonly || !canSubmit} className="btn btn-send" aria-label='Zgłoś projekt'>
            {submitting ? 'Zapisywanie...' : 'Zgłoś poparcie'} <i className="fa fa-paper-plane" />
          </button>
        </div>
      </div>
    </form>
  );
};

BudgetApplicationListOfSupportForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  applicationForm: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  budget: PropTypes.object.isRequired,
  readonly: PropTypes.bool,
  canSubmit: PropTypes.bool,
  unit: PropTypes.object,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ change }, dispatch);
}

BudgetApplicationListOfSupportForm = reduxForm({
  form: 'applicationSupportForm',
  enableReinitialize: true,
})(BudgetApplicationListOfSupportForm);

export default compose(connect(null, mapDispatchToProps))(BudgetApplicationListOfSupportForm);



// WEBPACK FOOTER //
// ./src/components/budget/BudgetApplicationListOfSupportForm.js